export default "__VITE_ASSET__f02e346f__"